import React, { useState } from 'react';
import { get } from 'lodash';
import axios from 'axios';

import {
  CSRF_TOKEN,
  addNotification,
} from '../../lib/helpers';

import {
  useModal,
} from '../../hooks';

import Modal from '../Modal';
import Notification from '../Notification';

const EditParameterModal = ({
  title,
  parameter: { equation: oldEquation, maxScore: oldMaxScore, key, parameterType },
  updateEndpoint,
  editableMaxScore
}) => {
  const [equation, setEquation] = useState(oldEquation)
  const [maxScore, setMaxScore] = useState(oldMaxScore || '')
  const [isLoading, setIsLoading] = useState(false)

  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModal = () => {
    modalSet(!modal)
  }

  const onSubmit = (e) => {
    e.preventDefault()
    setIsLoading(true)

    axios.put(updateEndpoint, {
      equation: equation,
      max_score: maxScore,
      authenticity_token: CSRF_TOKEN,
    })
      .then((res) => {
        if (res.status == 200 && get(res, 'data.message')) {
          addNotification({
            message: get(res, 'data.message'),
            type: Notification.NOTIFICATION_TYPES.success,
          })
        }
      })
      .catch((error) => {
        addNotification({
          message: get(error, 'response.data.message'),
          type: Notification.NOTIFICATION_TYPES.error,
        })
      })
      .then(() => {
        // We need to delay this because it's on a worker.
        // So it will not update immediately.
        window.setTimeout(() => {
          window.location.reload()
        }, 3000)
      })
  }

  return (
    <React.Fragment>
      <a
        onClick={onToggleModal}
        className='Table__controls__a Table__controls__a--pencil'
        title='Edit'
      />
      <Modal
        isActive={modal}
        onToggleModal={onToggleModal}
      >
        <form
          onSubmit={onSubmit}
        >
          <h3 className='Modal__h3'>{title}</h3>

          <div className='EditParameterModal'>
            <div className="User__form__col">
              <label className='User__form__label'>Key</label>
              <input
                type='text'
                className='Input'
                placeholder='Key'
                value={key}
                disabled
                readOnly
              />
              <label className='User__form__label'>Parameter Type</label>
              <input
                type='text'
                className='Input'
                placeholder='Parameter Type'
                value={parameterType}
                disabled
                readOnly
              />
              <label className='User__form__label'>Equation</label>
              <input
                type='text'
                className='Input'
                placeholder='Equation'
                value={equation}
                onChange={(e) => {
                  setEquation(e.target.value)
                }}
              />

              {
                editableMaxScore && parameterType == 'sum' &&
                  <React.Fragment>
                    <label className='User__form__label'>Max Score</label>
                    <input
                      type='number'
                      className='Input'
                      placeholder='Max Score'
                      value={maxScore}
                      onChange={(e) => {
                        setMaxScore(e.target.value)
                      }}
                    />
                  </React.Fragment>
              }
            </div>
            <div className='Modal__footer'>
              <a
                className='Button Button--gray-light'
                onClick={onToggleModal}
                disabled={isLoading}
              >
                Cancel
              </a>

              <button
                className='Button Button--blue'
                disabled={isLoading}
                ref={$submitButton}
                onClick={onSubmit}
              >
                {isLoading ? 'Loading …' : 'Update'}
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </React.Fragment>
  );
}

EditParameterModal.propTypes = {
};

export default EditParameterModal;
